import { render } from "./sjzy.vue?vue&type=template&id=5971aaa6&scoped=true"
import script from "./sjzy.vue?vue&type=script&lang=js"
export * from "./sjzy.vue?vue&type=script&lang=js"

import "./sjzy.vue?vue&type=style&index=0&id=5971aaa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5971aaa6"]])

export default __exports__